// Get DOM references for player parts
const cradlePlayer = document.getElementById('ggd-player');
const loadSetButtons = document.querySelectorAll('.set-index');
const toggleButtons = document.querySelectorAll('.toggle-button');
const mediaSets = document.querySelectorAll('.media-set');
const mediaFiles = document.querySelectorAll(
  '.media-set video, .media-set audio',
);
const playPauseButton = document.getElementById('play-pause');
const progressBar = document.getElementById('progress-bar-outer');
const progressBarInner = document.getElementById('progress-bar-inner');
const totalSets = document.getElementsByClassName('set-index').length;
let totalLength;
let mediaElements;

function cradleMediaPlayer() {
  const FADE_TIME = 0.1; // This is the duration of the crossfade. 100ms
  const audioContexts = []; // Audio Contexts will hold the bufffers for our audio
  const audioBuffers = []; // Holds the audio raw data
  const audioSources = []; // Where we stage the data to allow manipulation and playback
  const gainNodes = []; // Gain nodes allow volume manipulation
  const waveSurferInstances = []; // Waveforms
  let playTimeInterval = 0; // We will keep track of play time manually using an interval timer
  let elapsedTime = 0; // Store the time here
  let currentPlaybackSessionId = 0; // Keep track of the current audio instance. This changes when seeking.
  let currentSet = 0;

  playPauseButton.addEventListener('click', togglePlayPause);
  progressBar.addEventListener('click', seekAudio);

  mediaFiles.forEach((mediaFiles, index) => {
    mediaFiles.preload = 'auto'; // Remove preload flag from media items and commence download
  });

  function loadAudioSet(setIndex) {
    return new Promise((resolve, reject) => {
      resetPlayer();

      currentSet = setIndex;

      cradlePlayer.classList.add('no-interact'); // Put player into state that can't be interacted with when changing media sets

      // Close all the audio contexts, stopping all playback
      audioContexts.forEach((context) => {
        if (context) {
          context.close().catch((error) => {
            console.error('Error closing AudioContext:', error);
          });
        }
      });

      // Update mediaElements based on selected media set
      mediaElements = document.querySelectorAll(
        '[data-media-set="' +
          setIndex +
          '"] audio, [data-media-set="' +
          setIndex +
          '"] video',
      );

      // Create audio contexts and fetch the audio
      const fetchPromises = [];
      mediaElements.forEach((mediaElement, index) => {
        const audioUrl = mediaElement
          .querySelector('source')
          .getAttribute('src');
        audioContexts[index] = new AudioContext();
        fetchPromises.push(fetchAudio(audioUrl, index));
      });

      // Wait for all fetchAudio operations to complete
      Promise.all(fetchPromises)
        .then(() => {
          cradlePlayer.classList.remove('no-interact');
          resolve(); // Resolve the loadAudioSet promise after all audio is fetched
        })
        .catch((error) => {
          console.error('Error in loading audio sets:', error);
          reject(error); // Reject in case of an error
        });
    });
  }

  // Decode the audio from each file and place in a separate buffer
  function fetchAudio(url, index) {
    const ctx = audioContexts[index];

    // Fetch the file then decode it
    const load = async (src) => {
      const res = await fetch(src);
      if (!res.ok) throw new Error(`HTTP ${res.status} for ${src}`);
      const buf = await res.arrayBuffer();
      return ctx.decodeAudioData(buf);
    };

    return (async () => {
      try {
        audioBuffers[index] = await load(url);
      } catch (err) {
        // On failure we substitute 1s of silence instead

        console.warn(
          `[fetchAudio] ${url} failed – generating silent buffer.`,
          err,
        );

        // Generate 1‑second silent buffer
        audioBuffers[index] = ctx.createBuffer(
          1,
          ctx.sampleRate,
          ctx.sampleRate,
        );
      }

      // Create and connect gain nodes after fetching/decoding audio. Gain nodes allow volume adjustment
      gainNodes[index] = ctx.createGain();
      gainNodes[index].connect(ctx.destination);
      gainNodes[index].gain.value = index === 0 ? 0.7 : 0.01;

      // After audio has been decoded , put player into ready state
      if (index === 0) {
        totalLength = audioBuffers[index].duration;
        cradlePlayer.classList.remove('loading');
      }
    })();
  }

  function updateVisibleElement(className, targetIndex) {
    // Query for both the current visible element and the target element
    const currentElement = document.querySelector(`.${className}.visible`);
    const targetElement = document.querySelector(
      `[data-${className}="${targetIndex}"]`,
    );

    // Remove visible class from current element and apply it to the destination
    currentElement.classList.remove('visible');
    targetElement.classList.add('visible');
  }

  // Add event listeners to buttons that select an audio set
  loadSetButtons.forEach((button) => {
    button.addEventListener('click', async function () {
      const setIndex = parseInt(button.getAttribute('data-set-index'), 10);
      await loadAudioSet(setIndex);

      // Reset the track button state
      if (toggleButtons.length > 0) {
        toggleButtons.forEach((toggleBtn) => {
          toggleBtn.classList.remove('active');
        });
        toggleButtons[0].classList.add('active');
      }

      // Toggle playlist button/video set/meta set/waveworm visibility
      ['set-index', 'meta-set', 'media-set', 'wave-set'].forEach((className) =>
        updateVisibleElement(className, setIndex),
      );

      togglePlayPause();
    });
  });

  function playAllAudio() {
    currentPlaybackSessionId++; // Increment the session ID for a new playback session
    const localPlaybackSessionId = currentPlaybackSessionId;

    // Fill the buffers with audio.
    mediaElements.forEach((_, index) => {
      audioSources[index] = audioContexts[index].createBufferSource();
      audioSources[index].buffer = audioBuffers[index];
      audioSources[index].connect(gainNodes[index]); // Connect to gain node
      audioSources[index].start();
    });

    // Keep track of play time
    playTimer('start');

    // Once playback ends. Reset player
    audioSources[0].onended = function () {
      if (localPlaybackSessionId === currentPlaybackSessionId) {
        // Prevent player resetting when seeking, as this triggers .onended too
        resetPlayer();
        if (currentSet + 1 !== totalSets) {
          // Check to see if current set is the last one in the list
          playNext();
        }
      }
    };
  }

  function isMobile() {
    // Our definition of mobile is tablet and below. 1068px is also defined in our core styles as tablet.
    return window.matchMedia('(max-width: 1068px)').matches;
  }

  async function playNext() {
    if (!isMobile()) {
      // Toggle playlist button/video set/meta set/waveworm visibility
      ['set-index', 'meta-set', 'media-set', 'wave-set'].forEach((className) =>
        updateVisibleElement(className, currentSet + 1),
      );

      // Load next set of tracks and play
      await loadAudioSet(currentSet + 1);
      togglePlayPause();
    }
  }

  function pauseAllAudio() {
    audioContexts.forEach((context) => {
      context.suspend();
    });
    playTimer('pause');
  }

  function resumeAllAudio() {
    audioContexts.forEach((context) => {
      context.resume();
    });
    playTimer('start');
  }

  // Toggles play/pause state for the audio and any videos being played
  function togglePlayPause() {
    const visibleVideoSet = document.querySelector('.media-set.visible'); // Get the currently visible video set
    const videosInVisibleSet = visibleVideoSet.querySelectorAll('video'); // Get all videos in the visible set

    if (cradlePlayer.getAttribute('data-player-state') === 'playing') {
      pauseAllAudio();
      videosInVisibleSet.forEach((video) => video.pause()); // Pause all videos in the visible set
      playPauseButton.classList.toggle('playing');
      playPauseButton.setAttribute('aria-label', 'Play');
    } else if (cradlePlayer.getAttribute('data-player-state') === 'paused') {
      resumeAllAudio();
      videosInVisibleSet.forEach((video) => video.play()); // Play all videos in the visible set
      playPauseButton.classList.toggle('playing');
      playPauseButton.setAttribute('aria-label', 'Pause');
    } else {
      playAllAudio();
      videosInVisibleSet.forEach((video) => video.play()); // Play all videos in the visible set
      playPauseButton.classList.toggle('playing');
      playPauseButton.setAttribute('aria-label', 'Pause');
    }
  }

  // Add event listeners to buttons to toggle which track is audible
  if (toggleButtons.length > 0) {
    toggleButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const audioIndex = parseInt(
          button.getAttribute('data-audio-index'),
          10,
        );
        setAudibleTrack(audioIndex);
        toggleButtons.forEach((btn) => {
          btn.classList.remove('active');
        });
        button.classList.add('active');

        // Toggle visibility of vis-item (either an image or video) inside the active vis set

        const activeVisSet = document.querySelector('.media-set.visible');

        if (activeVisSet) {
          // Within the active vis set, remove the visible class from all videos
          activeVisSet.querySelectorAll('.vis-item').forEach((element) => {
            element.classList.remove('visible');
          });

          // Now, select the vis matching the audioIndex and add the visible class
          const targetVis = activeVisSet.querySelector(
            `.vis-item[data-media="${audioIndex}"]`,
          );
          if (targetVis) {
            targetVis.classList.add('visible');
          }
        }

        // Toggle waveform visibility to match active media

        const activeWaveSet = document.querySelector('.wave-set.visible');

        if (activeWaveSet) {
          // Within the active waveform set, remove the visible class from all waveform sets
          activeWaveSet.querySelectorAll('.waveform').forEach((element) => {
            element.classList.remove('visible');
          });

          // Now, select the waveform matching the audioIndex and add the visible class
          const targetWaveform = activeWaveSet.querySelector(
            `.waveform[data-wave="${audioIndex}"]`,
          );
          if (targetWaveform) {
            targetWaveform.classList.add('visible');
          }
        }
      });
    });
  }

  // Smoothly toggle between active audio tracks. Use a fade to avoid audio pop when using mute/unmute (still happens in webaudio)
  function setAudibleTrack(trackIndex) {
    const currentTime = audioContexts[0].currentTime; // Assuming all audioContexts share a similar currentTime

    gainNodes.forEach((gainNode, index) => {
      // Cancel any scheduled changes first to ensure smooth transitions
      gainNode.gain.cancelScheduledValues(currentTime);

      // Set the current value as the starting point for our ramp
      gainNode.gain.setValueAtTime(gainNode.gain.value, currentTime);

      if (index === trackIndex) {
        // Ramp up the volume to 0.7 over FADE_TIME
        gainNode.gain.linearRampToValueAtTime(0.7, currentTime + FADE_TIME);
      } else {
        // Ramp down the volume to 0.01 over FADE_TIME
        gainNode.gain.linearRampToValueAtTime(0.01, currentTime + FADE_TIME);
      }
    });
  }

  // Create a timer that we can run while the player is set to "playing";
  function updateTimeline() {
    if (audioContexts.length > 0) {
      elapsedTime += 0.01; // Add 10ms every interval
      const percentage = (elapsedTime / totalLength) * 100;
      progressBarInner.style.width = percentage + '%';
    }
  }

  // Keeps track of play time and also the player state clearing the interval will halt the timer
  function playTimer(action) {
    if (action === 'start') {
      // Start or resume updating the timeline
      if (playTimeInterval) {
        clearInterval(playTimeInterval);
      }
      playTimeInterval = setInterval(updateTimeline, 10); // Update every 10ms
      cradlePlayer.setAttribute('data-player-state', 'playing');
    } else if (action === 'pause') {
      if (playTimeInterval) {
        clearInterval(playTimeInterval);
      }
      cradlePlayer.setAttribute('data-player-state', 'paused');
    } else if (action === 'stop') {
      // Stop and reset the timeline
      if (playTimeInterval) {
        clearInterval(playTimeInterval);
      }
      elapsedTime = 0;
      updateTimeline();
      cradlePlayer.setAttribute('data-player-state', 'stopped');
    } else if (action === 'seek') {
      updateTimeline(); // Update the timeline immediately to reflect the seek position
    }
  }

  // Seek audio and video
  function seekAudio(event) {
    if (cradlePlayer.getAttribute('data-player-state') === 'stopped') {
      return; // Don't seek if player is in stopped state.
    }

    currentPlaybackSessionId++; // Increment the session ID as this is a new playback session
    const localPlaybackSessionId = currentPlaybackSessionId;

    // Get the position of the timeline when clicked
    const clickPosition =
      event.clientX - progressBar.getBoundingClientRect().left;
    const clickPercentage = clickPosition / progressBar.offsetWidth;
    const newTime = clickPercentage * totalLength;

    audioSources.forEach((source, index) => {
      if (source) {
        // Remove the current buffers
        source.disconnect();
        source.stop(0);
      }

      // Create a new buffer and start from the new time
      source = audioContexts[index].createBufferSource();
      source.buffer = audioBuffers[index];
      source.connect(gainNodes[index]);
      audioSources[index] = source;
      source.start(0, newTime);
    });

    // Seek the video
    document.querySelectorAll('.media-set.visible video').forEach((video) => {
      video.currentTime = newTime;
    });

    // Update the elapsed time and progress bar
    elapsedTime = newTime;
    progressBarInner.style.width = clickPercentage * 100 + '%';

    playTimer('seek'); // Update the timer

    audioSources[0].onended = function () {
      if (localPlaybackSessionId === currentPlaybackSessionId) {
        // Make sure to only reset when the track has reached the end
        resetPlayer();
        if (currentSet + 1 !== totalSets) {
          // Check to see if current set is the last one in the list
          playNext();
        }
      }
    };
  }

  // Reset player
  function resetPlayer() {
    playTimer('stop');

    // Reset play button state
    playPauseButton.classList.remove('playing');
    playPauseButton.setAttribute('aria-label', 'Play');

    // Reset all vis videos (if used)
    document.querySelectorAll('.media-set video').forEach((video) => {
      video.currentTime = 0; // Reset the video's playback time to the start
      video.pause(); // Ensure all videos are paused
    });

    // Remove the visible class from all vis-items
    document.querySelectorAll('.media-set .vis-item').forEach((element) => {
      element.classList.remove('visible');
    });

    // Add the visible class to the first vis-items in each set
    document
      .querySelectorAll('.media-set .vis-item[data-media="0"]')
      .forEach((element) => {
        element.classList.add('visible');
      });

    // Remove the visible class from all waveforms
    document.querySelectorAll('.wave-set .waveform').forEach((element) => {
      element.classList.remove('visible');
    });

    // Add the visible class to the first waveform in each set
    document
      .querySelectorAll('.wave-set .waveform[data-wave="0"]')
      .forEach((element) => {
        element.classList.add('visible');
      });

    // Reset toggle button state
    if (toggleButtons.length > 0) {
      toggleButtons.forEach((toggleBtn) => {
        toggleBtn.classList.remove('active');
      });
      toggleButtons[0].classList.add('active');
    }
  }

  // Function to initialize all waveforms on page load
  function initializeWaveforms() {
    // Create an array we get get the URLs from
    const trackSets = Array.from(mediaSets).map((mediaSet) => {
      return Array.from(mediaSet.querySelectorAll('source')).map((source) =>
        source.getAttribute('src'),
      );
    });

    const allAudioSources = trackSets.flat(); // Get all audio sources from all sets

    allAudioSources.forEach((source, index) => {
      const waveContainer = document.querySelector(
        `.waveform[data-waveform-id="${index}"]`,
      );
      if (waveContainer) {
        const wavesurfer = WaveSurfer.create({
          container: waveContainer,
          responsive: true,
          height: 40,
          cursorWidth: 0,
          barGap: 0,
          barHeight: 1,
          barMinHeight: 1,
          barWidth: 0,
        });
        wavesurfer.load(source);
        waveSurferInstances.push(wavesurfer);
      }
    });
  }

  initializeWaveforms();

  loadAudioSet(0); // Load the first media set in the list.
}

document.addEventListener('DOMContentLoaded', function () {
  // Interaction observer to load media files when player is in view
  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0]; // Directly access the first entry
      if (entry.isIntersecting) {
        cradleMediaPlayer();
        observer.unobserve(cradlePlayer); // Stop observing after first trigger
      }
    },
    { threshold: 0.1 },
  ); // 10% of the player is in view

  if (cradlePlayer) {
    observer.observe(cradlePlayer);
  }
});
